import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Admin from '@/components/Admin'
import TeamHome from '@/components/TeamHome'
import Login from '@/components/Login'
import RoomPicker from '@/components/RoomPicker'
import Report from '@/components/Report'
import StatusReports from '@/components/StatusReports'
import SuccinctReports from '@/components/SuccinctReports'
import GenerateReports from '@/components/GenerateReports'
import Reset from '@/components/Reset'
import Sync from '@/components/Sync'
import * as ROUNDS_API from '@/constants/roundsApiEndpoints'
Vue.use(Router)

import VueOpenAMAuth from '@/services/vue-openam.js'
Vue.use(VueOpenAMAuth, { authUrl: ROUNDS_API['API_ENDPOINT_AUTH'], logoutUrl: ROUNDS_API['API_ENDPOINT_LOGOUT'] });

var NProgress = require('nprogress');
NProgress.configure({
  showSpinner: false,
  trickleSpeed: 80
})
require('../../node_modules/nprogress/nprogress.css')

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      title: 'Home',
      component: Home,
      meta: {
        auth: false,
        inMenu: false
      }
    },
    {
      path: '/:teamId/admin',
      name: 'Admin',
      title: 'Admin',
      component: Admin,
      props: true,
      meta: {
        auth: true,
        inMenu: true,
        roles: [
          'Staff'
        ]
      }
    },
    {
      path: '/login',
      name: 'Login',
      title: 'Login',
      component: Login, // TODO: Is this route even needed?
      meta: {
        auth: true,
        inMenu: false
      }
    },
    {
      path: '/:teamId/room',
      name: 'RoomPicker',
      title: 'Room Picker',
      component: RoomPicker,
      props: true,
      meta: {
        auth: true,
        inMenu: true
      }
    },
    {
      path: '/:teamId/report/:roomId',
      name: 'Report',
      title: 'Report',
      component: Report,
      props: true,
      meta: {
        auth: true,
        inMenu: false
      }
    },
    {
      path: '/:teamId/sync',
      name: 'Sync',
      title: 'Sync Status',
      component: Sync,
      props: true,
      meta: {
        auth: true,
        inMenu: true
      }
    },
    {
      path: '/:teamId/status',
      name: 'Status',
      title: 'Weekly Reports',
      component: StatusReports,
      props: true,
      meta: {
        auth: true,
        inMenu: true,
        roles: [
          'Staff',
          'Client'
        ]
      }
    },
    {
      path: '/:teamId/summary',
      name: 'Summary',
      title: 'Summary Reports',
      component: SuccinctReports,
      props: true,
      meta: {
        auth: true,
        inMenu: true,
        roles: [
          'Staff',
          'Client'
        ]
      }
    },
    {
      path: '/:teamId/generate-reports',
      name: 'GenerateReports',
      title: 'Generate Reports',
      component: GenerateReports,
      props: true,
      meta: {
        auth: true,
        inMenu: true,
        roles: [
          'Staff'
        ]
      }
    },
    {
      path: '/reset',
      name: 'Reset',
      title: 'Reset',
      component: Reset,
      meta: {
        auth: true,
        inMenu: false
      }
    },
    {
      path: '/logout',
      name: 'Logout',
      title: 'Logout',
      component: Login, // TODO: Make this actually log out
      meta: {
        auth: true,
        inMenu: true
      }
    },
    {
      path: '/:teamId',
      name: 'TeamHome',
      title: 'Team Home',
      component: TeamHome,
      props: true,
      meta: {
        auth: true,
        inMenu: false
      }
    },
    {
      path: '/*',
      redirect: { name: 'Home' }
    }
  ]
})

// Helper function to send users to access denied with goto redirect
router.accessDenied = (goto) => {
  if (typeof goto === 'undefined') {
    goto = this.a.currentRoute.path
  }
  this.a.push({
    name: 'Home',
    query: {
      goto: goto
    }
  });
}
router.afterEach((to, from) => {
  NProgress.done()
})
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (to.meta.auth) {
    Vue.$auth.authWorkflowComplete().then((authenticated) => {
      if (!authenticated) {
        next({
          name: 'Home',
          query: {
            goto: to.path
          }
        });
        NProgress.done();
        // if the user has not logged in yet, redirect
      } else if (to.name === 'Logout') {
        Vue.$auth.authWorkflowComplete().then((authenticated) => {
          next({
            path: '/'
          });
        });
        Vue.$auth.logout();
        NProgress.done();
      } else if (!!to.params && !!to.params.teamId) {
        // Validate teamId path param against current user's teams
        if(!!Vue.$teamService.currentUserTeamIds.filter(it => it === to.params.teamId).length) {
          if (!!to.meta.roles && !to.meta.roles.find(role => role === Vue.$auth.user().roles[to.params.teamId])) {
            router.accessDenied()
          } else {
            next()
          }
        } else {
          next({ name: 'Home' })
        }
      } else {
        next()
      }
    });
    Vue.$auth.ready();
  } else {
    next()
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js